module.exports = __webpack_public_path__ + "img/StatementSample.472776bd.png";